import { isProblemDetails, type components } from '@hpd/contract';
import { queryOptions } from '@tanstack/react-query';

import { api } from '../api.ts';
import { ApiProblem } from './me.ts';

// CLI-01 at v1.984: who manages a client, a quote or a job. The people offered are the API's —
// those who can manage quotes — and the database refuses anyone else.

export type UserRef = components['schemas']['UserRefView'];

function problem(error: unknown, fallback: string): ApiProblem {
  return isProblemDetails(error)
    ? new ApiProblem(error.type, error.detail ?? error.title)
    : new ApiProblem('unknown', fallback);
}

export const accountManagersQuery = queryOptions({
  queryKey: ['account-managers'],
  queryFn: async () => {
    const { data, error } = await api.GET('/v1/account-managers');
    if (error) throw problem(error, 'Could not load who can be an account manager.');
    return data;
  },
});

export async function setClientAccountManager(clientId: string, accountManagerId: string | null) {
  const { data, error } = await api.PATCH('/v1/clients/{id}/account-manager', {
    params: { path: { id: clientId } },
    body: { accountManagerId },
  });
  if (error) throw problem(error, 'Could not change the account manager.');
  return data;
}

export async function setQuoteAccountManager(quoteId: string, accountManagerId: string | null) {
  const { data, error } = await api.PUT('/v1/quotes/{id}/account-manager', {
    params: { path: { id: quoteId } },
    body: { accountManagerId },
  });
  if (error) throw problem(error, 'Could not change the account manager.');
  return data;
}
